<template>
  <main class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <p class="text-base font-semibold text-primary">503</p>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        {{ $t('ui.errors.underMaintenance') }}
      </h1>
      <p class="mt-6 text-base leading-7 text-gray-600">{{ $t('ui.errors.underMaintenanceDescription') }}</p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <Button
          :label="$t('ui.errors.goBack')"
          @click="$router.go(-1)"
        />
        <a
          href="#"
          class="text-sm font-semibold text-gray-900"
        >
          {{ $t('ui.errors.contactSupport') }}
          <Icon type="arrow-right" />
        </a>
      </div>
    </div>
  </main>
</template>

<script setup>
import Button from '@/components/button/Button.vue'
import Icon from '@/components/icon/Icon.vue'
</script>

<style></style>
